import * as React from 'react';
import { Card, TextField, Page, Button } from '@shopify/polaris';

const Login: React.FC = () => {
  const [shopName, setShopName] = React.useState('');

  const handleLogin = React.useCallback(
    (evt) => {
      evt.preventDefault();

      window.location.href = 
        `${process.env.REACT_APP_BASE_URL}/api/shopify/auth?shop=${shopName.replace(
          '.myshopify.com',
          ''
        )}.myshopify.com`
      ;
    },
    [shopName]
  );

  return (
    <Page narrowWidth>
      <form onSubmit={handleLogin} method="get">
        <Card>
          <Card.Section>
            <h2 className="text-center font-bold">Login</h2>
            <div className="mt-8" />
            <TextField
              name="shop"
              value={shopName}
              label="Shop name"
              placeholder="Shop name"
              labelHidden
              suffix=".myshopify.com"
              onChange={setShopName}
            />
            <div className="mt-8" />
            <Button primary fullWidth submit>
              LOGIN
            </Button>
          </Card.Section>
        </Card>
      </form>
    </Page>
  );
};

export default Login;
